import { mapState, mapMutations, mapActions } from 'vuex';
import { tsNow } from '@/utils/timeSync';
import chatboxMixin from '@/mixins/chatbox';

export default {
  mixins: [chatboxMixin],
  data() {
    return {
      clientDateTime: null
    }
  },
  computed: {
    ...mapState('connection', ['canReconnect']),
    ...mapState('lesson', ['isLessonWithinGracePeriod']),
    ...mapState(['lessonStart', 'lessonEnd', 'gracePeriodEnd', 'lessonStatus']),
    ...mapState('socketio', ['socket'])
  },
  methods: {
    ...mapMutations('connection', ['setCanReconnect']),
    ...mapMutations('lesson', ['setIsLessonWithinGracePeriod', 'setLessonAsBeyondGracePeriod']),
    ...mapMutations(['setLessonStatus']),
    ...mapActions('recorder', ['stopRecorder']),

    // if beyond grace period, disconnect webrtc and socket connection
    autoDisconnect() {
      if (this.isBeyondGracePeriod()) {
        this.$logger.info('Lesson is beyond grace period', { operation: 'connection:terminate' });
        this.setCanReconnect(false);
        this.setLessonAsBeyondGracePeriod();
        this.stopRecorder();
      } else if(this.isWithinGracePeriod() && !this.isLessonWithinGracePeriod) {
        this.setIsLessonWithinGracePeriod(true)
      }

      if (!this.isEnableChatbox()) {
        this.disconnectSocket();
      }
    },
    disconnectSocket() {
      this.socket.disconnect(true);
    },
    isWithinLessonTime() {
      const now = tsNow();
      return this.lessonStart * 1000 < now && now <= this.lessonEnd * 1000;
    },
    isWithinGracePeriod() {
      const now = tsNow();
      return this.lessonEnd * 1000 < now && now <= this.gracePeriodEnd * 1000;
    },
    isBeyondGracePeriod() {
      return tsNow() > this.gracePeriodEnd * 1000
    }
  }
}
